import React, { useEffect, useState } from 'react'
import Header from "../Components/Header";
import sanityClient from "../client.js";
import { Link } from 'react-router-dom';
import moment from 'moment';

const Religion = () => {
    const [allPostsData, setAllPosts] = useState(null);

    useEffect(() => {
      sanityClient
        .fetch(
          `*[_type == "post" && categories[0]._ref == 'f38c3ff5-cbb3-4ba7-8602-c43cf9d1c18b']{
          title,
          slug,
          mainImage{
            asset->{
            _id,
            url
          }
        },
        excerpt,
        _createdAt,
        "name": author->name,
      }`
        )
        .then((data) => setAllPosts(data))
        .catch(console.error);
    }, []);
  return (
    <>
      <Header path="../images/religion.jpg" color="white" />

      <section className="px-4 py-24 mx-auto max-w-7xl">
        <h2 className="mb-2 text-3xl font-extrabold leading-tight text-gray-900">
          Blog Zone
        </h2>
        <p className="mb-20 text-lg text-gray-500">
          Thoughts on religion, the bible and God.
        </p>
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
        {allPostsData &&
    allPostsData.map((post, index) => (
        <div key={post.slug.current}>
        <Link to={ post.slug.current}>
          <img
            src={post.mainImage.asset.url} alt="Religion"
            className="object-cover w-full h-56 mb-5 bg-center rounded"
            loading="lazy"
          />
        </Link>
        <h2 className="mb-2 text-lg font-semibold text-gray-900">
          <Link to={ post.slug.current} className="text-gray-900 hover:text-purple-700">
            {post.title}
          </Link>
        </h2>
        <p className="mb-3 text-sm font-normal text-gray-500">
           {post?.excerpt}
        </p>
        <p className="mb-3 text-sm font-normal text-gray-500">
          <Link
            to="!#"
            className="font-medium text-gray-900 hover:text-purple-700"
          >
            {post?.name}
          </Link>
          <span className="ml-2">
            {moment(post._createdAt).format("dddd, MMMM Do YYYY")}
          </span>
        </p>
        </div>
    ))}
        </div>
        <div className="flex flex-col items-center justify-center mt-20 space-x-0 space-y-2 md:space-x-2 md:space-y-0 md:flex-row">
          <a
            href="!#"
            className="w-full rounded-full btn btn-light btn-xl md:w-auto"
          >
            Previous Page
          </a>
          <a
            href="!#"
            className="w-full rounded-full btn btn-light btn-xl md:w-auto"
          >
            Next Page
          </a>
        </div>
      </section>
    </>
  );
};

export default Religion;
